import { gql } from "@apollo/client";
import { HOLE_IN_ONE_FRAGMENT, EMPLOYMENTS_FRAGMENT } from "../fragments";

export const MY_FACILITY_QUERY = gql`
  query MyFacilityQuery {
    currentPerson {
      id
      ...EmploymentsFragment
    }
  }
  ${EMPLOYMENTS_FRAGMENT}
`;

export const FACILITY_HOLE_IN_ONES_QUERY = gql`
  query FacilityHoleInOnesQuery($facilityIds: [ID!]!, $limit: Int, $offset: Int) {
    facilityHoleInOnes(facilityIds: $facilityIds, limit: $limit, offset: $offset) {
      entries {
        ...HoleInOneFragment
      }
      totalCount
      hasMore
    }
  }
  ${HOLE_IN_ONE_FRAGMENT}
`;

export const CREATE_HOLE_IN_ONE_MUTATION = gql`
  mutation CreateHoleInOne($input: MembershipCreateHoleInOneInput!) {
    createHoleInOne(input: $input) {
      holeInOne {
        ...HoleInOneFragment
      }
      errors
    }
  }
  ${HOLE_IN_ONE_FRAGMENT}
`;
